import * as React from "react";

function SvgEfi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M18.396 7.134c.514.257.514.674 0 .931s-1.347.257-1.861 0c-.515-.257-.515-.674 0-.93.514-.258 1.347-.258 1.861 0zM15.454 10.818l-.772 4.636 11.59-5.409h-6.954v.773h-3.864z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09 0C1.527 0 0 1.269 0 2.833V30.91C0 32.474 1.526 34 3.09 34h27.82c1.564 0 3.09-1.526 3.09-3.09V3.09C34 1.527 32.474 0 30.91 0H3.09zm0 10.818L17 4.636l13.91 6.182L17 17.773 3.09 10.818zm6.183 4.636L6.182 17 17 21.636 27.818 17l-3.09-1.546 1.545-.772L30.909 17 17 23.182 3.09 17l4.637-2.318 1.546.772zm-3.091 7.728l3.09-1.546-1.545-.772-4.636 2.318L17 29.364l13.91-6.182-4.637-2.318-1.546.772 3.091 1.546L17 27.818 6.182 23.182z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgEfi;
